import { render } from "./AddDocumentTypeFobPopUp.vue?vue&type=template&id=5efa3d34&scoped=true"
import script from "./AddDocumentTypeFobPopUp.vue?vue&type=script&lang=js"
export * from "./AddDocumentTypeFobPopUp.vue?vue&type=script&lang=js"

import "./AddDocumentTypeFobPopUp.vue?vue&type=style&index=0&id=5efa3d34&scoped=true&lang=css"

import exportComponent from "/var/www/dev.newtoncommoditiesscripts.com/vue-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5efa3d34"]])

export default __exports__